document.querySelectorAll('[id^="blogTrack-"]').forEach((track) => {
  const section = track.closest('section');
  const prevBtn = section.querySelector('.prev');
  const nextBtn = section.querySelector('.next');
  const dotsContainer = section.querySelector('.carousel-dots');
  const controls = section.querySelector('.carousel-controls');

  let current = 0;

  function isMobile() {
    return window.innerWidth <= 700;
  }

  function visibleCards() {
    return isMobile() ? 1 : 4;
  }

  function isCarousel() {
    const total = track.children.length;
    return isMobile() ? total > 1 : total > 4;
  }

  function buildDots() {
    dotsContainer.innerHTML = '';
    if (!isCarousel()) return;

    const total = track.children.length;
    const steps = Math.max(1, total - visibleCards() + 1);

    for (let i = 0; i < steps; i++) {
      const dot = document.createElement('button');
      dot.className = 'dot' + (i === current ? ' active' : '');
      dot.onclick = () => goTo(i);
      dotsContainer.appendChild(dot);
    }
  }

  function goTo(index) {
    if (!isCarousel()) return;

    const maxIndex = track.children.length - visibleCards();
    current = Math.max(0, Math.min(index, maxIndex));

    let shift = isMobile()
      ? `calc(-${current * 75}% - ${current * 16}px)`
      : `calc(-${current * 30}% - ${current * 20}px)`;

    track.style.transform = `translateX(${shift})`;

    prevBtn.disabled = current === 0;
    nextBtn.disabled = current === maxIndex;

    dotsContainer.querySelectorAll('.dot').forEach((d, i) =>
      d.classList.toggle('active', i === current)
    );
  }

  function updateUI() {
    if (isCarousel()) {
      track.classList.add('carousel-active');
      controls.classList.add('show');
    } else {
      track.classList.remove('carousel-active');
      controls.classList.remove('show');
      track.style.transform = '';
      current = 0;
    }
  }

  prevBtn.addEventListener('click', () => goTo(current - 1));
  nextBtn.addEventListener('click', () => goTo(current + 1));

  function init() {
    updateUI();
    buildDots();
    goTo(0);
  }

  init();

  window.addEventListener('resize', () => {
    updateUI();
    buildDots();
    goTo(current);
  });
});